import { format, isToday, parseISO } from 'date-fns'

export const formatUnixMsTimeAsLocalBrowserTime = (unixTime) => {
    // Automatically converts unix UTC time to user browser/system time
    return format(unixTime, 'yyyy-MM-dd HH:mm')
}

export const validateIfDateToday = (date) => {
    //return isToday(parseISO(date))
    return isToday(date)
}

export const parseStringToDate = (dateStr) => {
    return parseISO(dateStr)
} 
